import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { setupAxiosInterceptors } from "app/utils/axios";
import { useSnackbar } from "app/c1component/SnackbarContext";

const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const openSnackbar = useSnackbar();

  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current && typeof openSnackbar === "function") {
      console.log("[useAxiosInterceptor] Interceptor initialized");
      setupAxiosInterceptors(navigate, openSnackbar);
      isInitialized.current = true;
    }
  }, [navigate, openSnackbar]);
};

export default useAxiosInterceptor;
